// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IModuleI18n } from '@platform/core/types/modularity/IModuleI18n';
import type { IModuleManifest } from '@platform/core/types/modularity/IModuleManifest';

/** Пакет модуля «Навчання» (Learning, ключ `learn`, група `development`). */
export const learningManifest: IModuleManifest = {
  key: 'learn',
  group: 'development',
  slug: 'learning',
  prefix: 'LRN',
  name: { en: 'Learning', uk: 'Навчання' },
  entities: [
    { key: 'learn', slug: 'learn', name: { en: 'Courses', uk: 'Курси' }, main: true },
    { key: 'enrol', slug: 'enrol', name: { en: 'Enrolments', uk: 'Записи на навчання' }, main: false },
  ],
  loadState: () => import('./state/learningSlice').then((m) => m.learningSlice),
  loadI18n: (lng) => (lng === 'uk' ? import('./i18n/uk.json') : import('./i18n/en.json')).then((m) => m.default as IModuleI18n),
  loadDefinition: () => import('./definition').then((m) => m.definition),
};
